import React, { Component } from 'react'
import { getValueCookie } from '../../services/cookieService';
import { getInformationWithData } from '../../services/CABE';
import "../../css/general-style.css"
import '../../css/table-responsive.css'
import "../../css/dashboard.css"
import { getIndexElement } from '../../functions/searchInObject';
import { pricesFormat } from '../../functions/pricesFormat';
import { ItemDesc, NumberFormat, OrderArray } from '../../functions/generalFunctions';
import { v4 as uuidv4 } from 'uuid';
import ExcelDocument from '../../components/ExcelDocument';
import { getDateFromReports } from '../../functions/dateFormat';
import { ReportPriceMargin } from '../../functions/generateDataSetExcel';
import LoadingWindow from '../../components/LoadingWindow';
import { BsFileArrowUpFill, BsFileArrowDownFill } from "react-icons/bs";
import { AiOutlineReload, AiOutlineBarChart } from "react-icons/ai";

// Menu
import { Menu } from "../../components/Menu/Menu";

export default class MargenesPrecioV2 extends Component {
    constructor(props) {
        super(props)
        this.ModalLoading = React.createRef();
    }
    state = {
        Products: [],
        ProductsFilter: [],
        TableHeaders: [],
        flag: true
    }

    async getProductsMargin() {
        this.ModalLoading.current.showState(true);
        const my7Data = {
            idCompany: Number(getValueCookie('CompanyId'))
        }
        const my7Result = await getInformationWithData('/Items/margin', my7Data)
        if (getValueCookie('CompanyId') !== '6') {

            if (my7Result.status.code === 1) {
                let temporal = []

                for (const item of my7Result.result) {
                    const index = getIndexElement(temporal, 'ItemCode', item.ItemCode)
                    if (index === -1) {
                        const it = {
                            ItemCode: item.ItemCode,
                            ItemCodeDesc: item.ItemCodeDesc,
                            ProductLine: item.ProductLineDesc,
                            UnitCost: item.LastTotalUnitCost,
                            PricesLevels: []

                        }
                        const priceLev = {
                            PriceLevel: item.CustomerPriceLevel,
                            LevelCost: item.DiscountMarkup1 === 0 ? '-' : item.DiscountMarkup1,
                            RealMargin: item.DiscountMarkup1 === 0 ? '-' : ((Number(item.DiscountMarkup1) - Number(item.LastTotalUnitCost)) / (Number(item.DiscountMarkup1))) * 100
                        }
                        it.PricesLevels.push(priceLev)
                        temporal.push(it)
                    } else {
                        const priceLev = {
                            PriceLevel: item.CustomerPriceLevel,
                            LevelCost: item.DiscountMarkup1 === 0 ? '-' : item.DiscountMarkup1,
                            RealMargin: item.DiscountMarkup1 === 0 ? '-' : ((Number(item.DiscountMarkup1) - Number(temporal[index].UnitCost)) / (Number(item.DiscountMarkup1))) * 100
                        }
                        temporal[index].PricesLevels.push(priceLev)
                    }
                }
                let headers = []
                for (const item of temporal) {
                    for (const pricelevel of item.PricesLevels) {
                        const index = getIndexElement(headers, 'Level', pricelevel.PriceLevel)
                        if (index === -1) {
                            const head = {
                                Level: pricelevel.PriceLevel,
                                Title1: "Level " + pricelevel.PriceLevel,
                                Title2: "Real Mark-Up Level " + pricelevel.PriceLevel
                            }
                            headers.push(head)
                        }
                    }


                }
                for (const item of temporal) {
                    if (item.PricesLevels.length !== headers.length) {
                        for (const head of headers) {
                            const index = getIndexElement(item.PricesLevels, 'PriceLevel', head.Level)
                            if (index === -1) {
                                const priceLev = {
                                    PriceLevel: head.Level,
                                    LevelCost: '-',
                                    RealMargin: '-'
                                }
                                item.PricesLevels.push(priceLev)
                            }
                        }
                    }
                }
                temporal=await ItemDesc(temporal,'ItemCodeDesc','ItemCode')
                this.setState({ Products: temporal, ProductsFilter: temporal, TableHeaders: headers })
            }
        } else if (getValueCookie('CompanyId') === '6') {
            const data = {
                company: 'Altitude Atlanta',
                idcompany: '6',
                priceLevel: 1,
                Component: null
            }

            const invent = await getInformationWithData('/Items/get', data)
            
                //data.company = 'Mayaland Atlanta'
                //data.idcompany = '3'
                const respuesta2 = await getInformationWithData('/Items/get', data);

            
                invent.status.code = respuesta2.status.code
                for (const item of respuesta2.data) {
                    const index = getIndexElement(invent.data, 'itemCode', item.itemCode)
                    if (index !== -1) {
                        invent.data = invent.data.splice(index, 1)
                    }
                }
                invent.data = invent.data.concat(respuesta2.data)
           
                if(invent.status.code===1){
                    let temporal = []
                    for (const item of invent.data) {
                        const index = getIndexElement(temporal, 'itemCode', item.itemCode)
                        let unitPriceAl1 = 0;
                        if (index === -1) {
                            const it = {
                                ItemCode: item.itemCode,
                                ItemCodeDesc: item.abbreviatedDesc,
                                ProductLine: item.ProductLineDesc,
                                // UnitCost: item.LastTotalUnitCost/0.95,
                                UnitCost: item.LastTotalUnitCost,
                                PricesLevels: []
    
                            }

                            if(!item.UnitPriceALT){
                                item.UnitPriceALT=item.UnitPrice
                            }
                            
                            // Validar unitPrice de Altitude y si es menor a n1 de mayaland
                            const unitPriceAltitude = item.LastTotalUnitCost / ( 1 - (Number(item.MarkUp)/100));
                            unitPriceAl1 = unitPriceAltitude.toFixed(2);
                            const my7ItemN1 = my7Result.result.find(obj => obj.ItemCode === item.itemCode);
                            if(my7ItemN1 !== undefined && unitPriceAl1 < my7ItemN1.DiscountMarkup1){
                                unitPriceAl1 = my7ItemN1.DiscountMarkup1
                            }


                            const priceLev = {
                                PriceLevel: '1',
                                LevelCost: unitPriceAl1 === 0 ? '-' : unitPriceAl1,
                                // RealMargin: unitPriceAl1 === 0 ? '-' : ((unitPriceAl1 - (Number(item.LastTotalUnitCost)/0.95)) / (unitPriceAl1)) * 100
                                RealMargin: unitPriceAl1 === 0 ? '-' : ((unitPriceAl1 - Number(item.LastTotalUnitCost)) / (unitPriceAl1)) * 100
                            }
                            it.PricesLevels.push(priceLev)
                            temporal.push(it)
                        } else {
                            const priceLev = {
                                PriceLevel: '1',
                                LevelCost: unitPriceAl1 === 0 ? '-' : unitPriceAl1,
                                RealMargin: unitPriceAl1 === 0 ? '-' : ((unitPriceAl1 - Number(temporal[index].UnitCost)) / (Number(item.UnitPriceALT))) * 100
                            }
                            temporal[index].PricesLevels.push(priceLev)
                        }
                    }

                    let headers = []
                    for (const item of temporal) {
                        for (const pricelevel of item.PricesLevels) {
                            const index = getIndexElement(headers, 'Level', pricelevel.PriceLevel)
                            if (index === -1) {
                                const head = {
                                    Level: pricelevel.PriceLevel,
                                    Title1: "Level " + pricelevel.PriceLevel,
                                    Title2: "Real Mark-Up Level " + pricelevel.PriceLevel
                                }
                                headers.push(head)
                            }
                        }
    
    
                    }
                    for (const item of temporal) {
                        if (item.PricesLevels.length !== headers.length) {
                            for (const head of headers) {
                                const index = getIndexElement(item.PricesLevels, 'PriceLevel', head.Level)
                                if (index === -1) {
                                    const priceLev = {
                                        PriceLevel: head.Level,
                                        LevelCost: '-',
                                        RealMargin: '-'
                                    }
                                    item.PricesLevels.push(priceLev)
                                }
                            }
                        }
                    }

                    temporal=await ItemDesc(temporal,'ItemCodeDesc','ItemCode')        
    
                    this.setState({ Products: temporal, ProductsFilter: temporal, TableHeaders: headers })
                }

            


        }

        this.ModalLoading.current.showState(false);
        document.getElementById("excelContainer").classList.remove("d-none");
        document.getElementById("loadDataContainer").classList.replace("col-12", "col-6");
    }

    contains(parametro, busqueda) {
        if(parametro&&busqueda){
        return parametro.toString().toLowerCase().includes(busqueda.toLocaleLowerCase())
        }
        return false
    }

    searchPriceMargin = e => {

        let search = e.target.value;
        if(search){
            let Products = this.state.Products.filter((item) => {
                if (((
                    this.contains(item.ItemCode, search) ||
                    this.contains(item.ProductLine, search) ||
                    this.contains(item.ItemCodeDesc, search)
    
                ))
                ) {
                    return item
                } else {
                    return null
                }
            });
            this.setState({ ProductsFilter: Products });
        }else{
            let Products=this.state.Products
            this.setState({ ProductsFilter: Products });
        }

    }

    OrderPriceMargins(option) {
        var temporal = this.state.ProductsFilter
        switch (option) {
            case "ItemCode":
                temporal = OrderArray(temporal, "ItemCode", this.state.flag)
                this.setState({ ProductsFilter: temporal, flag: !this.state.flag })
                break;
            case "ProductLine":
                temporal = OrderArray(temporal, "ProductLine", this.state.flag)
                this.setState({ ProductsFilter: temporal, flag: !this.state.flag })
                break;
            case "UnitCost":
                temporal = OrderArray(temporal, "UnitCost", this.state.flag)
                this.setState({ ProductsFilter: temporal, flag: !this.state.flag })
                break;
            default:
                break;
        }
    }

    OrderByPriceLevel(position, key) {
        var arreglo = this.state.ProductsFilter
        var l = arreglo.length

        if (this.state.flag) {
            for (let i = 0; i < l; i++) {
                for (let j = 0; j < l - 1 - i; j++) {
                    if ((arreglo[j].PricesLevels[position][key] === '-' ? '0' : arreglo[j].PricesLevels[position][key]) > (arreglo[j + 1].PricesLevels[position][key] === '-' ? '0' : arreglo[j + 1].PricesLevels[position][key])) {
                        [arreglo[j], arreglo[j + 1]] = [arreglo[j + 1], arreglo[j]];
                    }
                }
            }
        } else {
            for (let i = 0; i < l; i++) {
                for (let j = 0; j < l - 1 - i; j++) {
                    if ((arreglo[j].PricesLevels[position][key] === '-' ? '0' : arreglo[j].PricesLevels[position][key]) < (arreglo[j + 1].PricesLevels[position][key] === '-' ? '0' : arreglo[j + 1].PricesLevels[position][key])) {
                        [arreglo[j], arreglo[j + 1]] = [arreglo[j + 1], arreglo[j]];
                    }
                }
            }
        }

        this.setState({ ProductsFilter: arreglo, flag: !this.state.flag })
    }


    render() {
        const hasData = this.state.Products.length > 0;

        return (
            <div className="dash-page container-fluid pb-5">
                <Menu Refresh={this.state.Refresh} Father={this} />
                <LoadingWindow ref={this.ModalLoading} />

                <div className="container-fluid" style={{ paddingTop: '1.5rem' }}>

                    {/* ── Hero ────────────────────────────────────────────── */}
                    <div style={{
                        background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 60%, #2563EB 100%)',
                        borderRadius: '16px',
                        padding: '2rem 2.5rem',
                        marginBottom: '2rem',
                        marginTop: '2rem',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        gap: '1rem',
                    }}>
                        <div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
                                <AiOutlineBarChart style={{ fontSize: '1.75rem', opacity: 0.9 }} />
                                <h2 style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 800, fontSize: '1.75rem', margin: 0 }}>
                                    Price Margin Report 
                                </h2>
                            </div>
                            <p style={{ margin: 0, opacity: 0.8, fontSize: '0.9375rem' }}>
                                Item price vs cost breakdown by price level · {getValueCookie('Company')}
                            </p>
                        </div>
                        <div style={{
                            background: 'rgba(255,255,255,0.1)',
                            border: '1px solid rgba(255,255,255,0.2)',
                            borderRadius: '10px',
                            padding: '0.5rem 1.25rem',
                            fontSize: '0.875rem',
                            fontWeight: 600,
                        }}>
                            Margins
                        </div>
                    </div>

                    {/* ── Action bar ──────────────────────────────────────── */}
                    <div className="row g-3 mb-4 align-items-center">
                        <div id="loadDataContainer" className="col-auto">
                            <button
                                onClick={() => this.getProductsMargin()}
                                type="button"
                                style={{
                                    background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
                                    border: 'none',
                                    borderRadius: '10px',
                                    color: 'white',
                                    padding: '0.75rem 1.5rem',
                                    fontWeight: 600,
                                    fontSize: '0.9375rem',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.5rem',
                                    boxShadow: '0 4px 6px -1px rgba(0,0,0,0.15)',
                                }}
                            >
                                <AiOutlineReload /> Load Data
                            </button>
                        </div>

                        {hasData && (
                            <div id="excelContainer" className="col-auto">
                                <ExcelDocument
                                    hidden={false}
                                    archname={'Price Margins ' + getValueCookie('Company') + ' ' + getDateFromReports()}
                                    sheetname={'Price Margins ' + getValueCookie('Company')}
                                    data={ReportPriceMargin(this.state.TableHeaders, this.state.Products, '$')}
                                />
                            </div>
                        )}

                        {hasData && (
                            <div className="col">
                                <input
                                    type="text"
                                    autoComplete="off"
                                    id="searchPriceMarginItem"
                                    placeholder="Search by item code, product line or description…"
                                    onChange={this.searchPriceMargin}
                                    style={{
                                        width: '100%',
                                        padding: '0.75rem 1rem',
                                        border: '1.5px solid #E2E8F0',
                                        borderRadius: '10px',
                                        fontSize: '0.9375rem',
                                        outline: 'none',
                                        transition: 'border-color 0.2s',
                                    }}
                                    onFocus={e => e.target.style.borderColor = '#2563EB'}
                                    onBlur={e => e.target.style.borderColor = '#E2E8F0'}
                                />
                            </div>
                        )}
                    </div>

                    {/* ── Table ───────────────────────────────────────────── */}
                    {hasData && (
                        <div className="tableFixHeadSmall" style={{ maxHeight: '70vh' }}>
                            <table className="table table-clean align-middle">
                                <thead>
                                    <tr>
                                        {/* Base columns */}
                                        <th onClick={() => this.OrderPriceMargins("ItemCode")} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                            <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                Item Code
                                                <span style={{ display: 'flex', flexDirection: 'column', opacity: 0.5, lineHeight: 0.8 }}>
                                                    <BsFileArrowUpFill size={9} /><BsFileArrowDownFill size={9} />
                                                </span>
                                            </span>
                                        </th>
                                        <th onClick={() => this.OrderPriceMargins("ProductLine")} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                            <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                Product Line
                                                <span style={{ display: 'flex', flexDirection: 'column', opacity: 0.5, lineHeight: 0.8 }}>
                                                    <BsFileArrowUpFill size={9} /><BsFileArrowDownFill size={9} />
                                                </span>
                                            </span>
                                        </th>
                                        <th>Description</th>
                                        <th className="text-end" onClick={() => this.OrderPriceMargins("UnitCost")} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '4px' }}>
                                                Last Unit Cost
                                                <span style={{ display: 'flex', flexDirection: 'column', opacity: 0.5, lineHeight: 0.8 }}>
                                                    <BsFileArrowUpFill size={9} /><BsFileArrowDownFill size={9} />
                                                </span>
                                            </span>
                                        </th>

                                        {/* Price level column groups */}
                                        {this.state.TableHeaders.map((head, h) => {
                                            const cls = (h + 1) % 2 === 1 ? 'table-blue-header' : 'table-aqua-header';
                                            return (
                                                <React.Fragment key={h}>
                                                    <th className={cls} onClick={() => this.OrderByPriceLevel(h, "LevelCost")} style={{ cursor: 'pointer', whiteSpace: 'nowrap', textAlign: 'right' }}>
                                                        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '4px' }}>
                                                            {head.Title1}
                                                            <span style={{ display: 'flex', flexDirection: 'column', opacity: 0.5, lineHeight: 0.8 }}>
                                                                <BsFileArrowUpFill size={9} /><BsFileArrowDownFill size={9} />
                                                            </span>
                                                        </span>
                                                    </th>
                                                    <th className={cls} onClick={() => this.OrderByPriceLevel(h, "RealMargin")} style={{ cursor: 'pointer', whiteSpace: 'nowrap', textAlign: 'center' }}>
                                                        <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
                                                            {head.Title2}
                                                            <span style={{ display: 'flex', flexDirection: 'column', opacity: 0.5, lineHeight: 0.8 }}>
                                                                <BsFileArrowUpFill size={9} /><BsFileArrowDownFill size={9} />
                                                            </span>
                                                        </span>
                                                    </th>
                                                </React.Fragment>
                                            );
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.ProductsFilter.map((item, i) => (
                                        <tr key={i}>
                                            <td>{item.ItemCode}</td>
                                            <td>{item.ProductLine}</td>
                                            <td>{item.ItemCodeDesc}</td>
                                            <td className="text-end">${NumberFormat(pricesFormat(item.UnitCost))}</td>
                                            {item.PricesLevels.map((price) => (
                                                <React.Fragment key={uuidv4()}>
                                                    <td className="text-end">
                                                        {price.LevelCost !== '-' ? '$' + NumberFormat(pricesFormat(price.LevelCost)) : '—'}
                                                    </td>
                                                    <td className="text-center">
                                                        <span style={{
                                                            display: 'inline-block',
                                                            padding: '2px 8px',
                                                            borderRadius: '999px',
                                                            fontSize: '0.78rem',
                                                            fontWeight: 600,
                                                            background: price.RealMargin !== '-' && Number(price.RealMargin) >= 20
                                                                ? 'rgba(16,185,129,0.1)' : 'rgba(245,158,11,0.1)',
                                                            color: price.RealMargin !== '-' && Number(price.RealMargin) >= 20
                                                                ? '#059669' : '#D97706',
                                                        }}>
                                                            {price.RealMargin !== '-' ? NumberFormat(pricesFormat(price.RealMargin)) + '%' : '0.00%'}
                                                        </span>
                                                    </td>
                                                </React.Fragment>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {/* Empty state */}
                    {!hasData && (
                        <div style={{ textAlign: 'center', padding: '4rem 2rem', color: '#94A3B8' }}>
                            <AiOutlineBarChart style={{ fontSize: '3rem', marginBottom: '1rem', opacity: 0.4 }} />
                            <p style={{ margin: 0, fontSize: '1rem' }}>Click <strong style={{ color: '#1e3a8a' }}>Load Data</strong> to fetch price margins.</p>
                        </div>
                    )}

                </div>
            </div>
        );
    }
}
